<template>
  <b-modal
    :visible="value"
    :title="tituloModal"
    modal-class="campaign-modal-custom"
    centered
    @hidden="fecharModal"
  >
    <!-- Indicador de Auto-save -->
    <transition name="fade">
      <div
        v-if="salvandoRascunho"
        class="auto-save-indicator"
      >
        <b-spinner
          small
          class="mr-1"
        />
        <small>Salvando rascunho...</small>
      </div>
    </transition>

    <!-- Indicador de Steps -->
    <div class="steps-indicator mb-4">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step-item"
        :class="{
          'active': stepAtual === index,
          'completed': stepAtual > index
        }"
        @click="irParaStep(index)"
      >
        <div class="step-circle">
          <feather-icon
            v-if="stepAtual > index"
            icon="CheckIcon"
            size="16"
          />
          <span v-else>{{ index + 1 }}</span>
        </div>
        <span class="step-label">{{ step.label }}</span>
      </div>
    </div>

    <b-row class="campaign-form-layout">
      <!-- Coluna do Formulário -->
      <b-col
        cols="12"
        :lg="stepAtual === 0 ? 12 : 7"
        class="form-column"
      >
        <b-form @submit.prevent="avancarOuSalvar">
          <!-- Step 1: Como Funciona -->
          <div
            v-show="stepAtual === 0"
            class="step-content"
          >

            <!-- Como funciona -->
            <div>
              <h5 class="mb-1">
                Crie sua campanha de WhatsApp em 3 passos
              </h5>
              <p class="how-description small mb-0">
                Leva poucos minutos para configurar. Você só precisa seguir essas etapas:
              </p>
            </div>
            <div class="how-it-works mb-4">
              <div class="how-it-works-grid">
                <div class="how-it-works-item">
                  <div class="how-icon bg-light-primary">
                    <feather-icon
                      icon="FileTextIcon"
                      size="20"
                      class="text-primary"
                    />
                  </div>
                  <div>
                    <strong class="d-block mb-0">1. Crie e aprove seu template</strong>
                    <small class="how-description">Defina a mensagem que será enviada aos clientes. Antes do envio, ela precisa ser aprovada pela Meta, esse processo pode levar até <strong>24 horas.</strong></small>
                  </div>
                </div>
                <div class="how-it-works-item">
                  <div class="how-icon bg-light-success">
                    <feather-icon
                      icon="UsersIcon"
                      size="20"
                      class="text-success"
                    />
                  </div>
                  <div>
                    <strong class="d-block mb-0">2. Defina Audiência</strong>
                    <small class="how-description">Escolha quem vai receber a campanha. Você pode segmentar seus contatos com base em critérios como comportamento ou dados do cliente.</small>
                  </div>
                </div>
                <div class="how-it-works-item">
                  <div class="how-icon bg-light-warning">
                    <feather-icon
                      icon="CalendarIcon"
                      size="20"
                      class="text-warning"
                    />
                  </div>
                  <div>
                    <strong class="d-block mb-0">3. Configure e dispare a campanha</strong>
                    <small class="how-description">Revise as informações, escolha o momento do envio e publique sua campanha.</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center mt-3">
              <p class="text-muted mb-0">
                <feather-icon
                  icon="InfoIcon"
                  size="14"
                  class="mr-1"
                />
                Clique em <strong>Avançar</strong> para começar a configurar sua campanha.
              </p>
            </div>
          </div>

          <!-- Step 2: Template e Mídia -->
          <div
            v-show="stepAtual === 1"
            class="step-content"
          >
            <div class="step-header mb-3">
              <h5 class="mb-1">
                Template
              </h5>
              <p class="text-muted small mb-0">
                Escolha o template ou crie um novo
              </p>
            </div>

            <!-- Template -->
            <b-form-group
              label="Template"
              label-for="template_name"
              :state="validacao.template_name"
            >
              <!-- Se não tem templates disponíveis -->
              <div
                v-if="templates.length === 0 && !carregandoTemplates"
                class="no-templates-container"
              >
                <div class="no-templates-content">
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="48"
                    class="text-warning mb-3"
                  />
                  <h5 class="mb-2">
                    Nenhum Template Disponível
                  </h5>
                  <p class="text-muted mb-3">
                    Você precisa criar e aprovar templates no WhatsApp antes de criar campanhas.
                  </p>
                  <b-button
                    variant="primary"
                    @click="irParaTemplates"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      size="16"
                      class="mr-50"
                    />
                    Criar Template
                  </b-button>
                </div>
              </div>

              <!-- Seletor normal de template -->
              <div
                v-else
                class="template-selector-wrapper"
              >
                <div
                  v-if="!form.template_name"
                  class="template-action-cards"
                >
                  <div
                    class="template-action-card template-action-select"
                    @click="abrirModalTemplates"
                  >
                    <div class="action-icon-wrapper bg-light-primary">
                      <feather-icon
                        icon="FileTextIcon"
                        size="28"
                        class="text-primary"
                      />
                    </div>
                    <h6 class="mb-1">
                      Selecionar Template
                    </h6>
                    <p class="text-muted small mb-0">
                      Escolha um template já criado e aprovado
                    </p>
                  </div>

                  <div
                    class="template-action-card template-action-create"
                    @click="irParaTemplates"
                  >
                    <div class="action-icon-wrapper bg-light-success">
                      <feather-icon
                        icon="PlusCircleIcon"
                        size="28"
                        class="text-success"
                      />
                    </div>
                    <h6 class="mb-1">
                      Criar Novo Template
                    </h6>
                    <p class="text-muted small mb-0">
                      Crie e envie para aprovação do WhatsApp
                    </p>
                  </div>
                </div>
                <div
                  v-else
                  class="template-selected"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="CheckCircleIcon"
                        size="20"
                        class="text-success mr-2"
                      />
                      <div>
                        <strong>{{ form.template_name }}</strong>
                        <br>
                        <small class="text-muted">Template selecionado</small>
                      </div>
                    </div>
                    <div>
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="abrirModalTemplates"
                      >
                        <feather-icon
                          icon="RefreshCwIcon"
                          size="14"
                          class="mr-50"
                        />
                        Trocar
                      </b-button>
                      <b-button
                        variant="outline-danger"
                        size="sm"
                        class="ml-1"
                        @click="removerTemplate"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          size="14"
                        />
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <b-form-invalid-feedback :state="validacao.template_name">
                Template é obrigatório
              </b-form-invalid-feedback>
            </b-form-group>

            <!-- Modal de Seleção de Templates -->
            <modal-selecao-templates
              v-model="modalTemplatesVisivel"
              :templates="templates"
              :carregando="carregandoTemplates"
              @template-selecionado="onTemplateSelecionado"
            >
              <template #info-text>
                <strong>Apenas templates aprovados</strong> pelo WhatsApp estão disponíveis para uso em campanhas.
              </template>
              <template #empty-text>
                Crie templates e aguarde a aprovação do WhatsApp para utilizá-los em campanhas.
              </template>
            </modal-selecao-templates>

            <!-- Indicador de carregamento da mídia do template -->
            <b-form-group
              v-if="uploadando && templateMediaType"
              label="Mídia da Campanha"
            >
              <div class="template-media-loading">
                <b-spinner
                  variant="primary"
                  small
                  class="mr-2"
                />
                <span>Carregando mídia do template...</span>
              </div>
              <b-progress
                :value="progressoUpload"
                :max="100"
                show-progress
                animated
                class="mt-2"
              />
            </b-form-group>

            <!-- Upload de Mídia (Imagem ou Vídeo) - Só mostra se o template precisa de mídia E não veio do template E não está carregando -->
            <b-form-group
              v-if="false"
              label="Mídia da Campanha"
              label-for="media_upload"
              :description="templateTipoMidia === 'VIDEO' ? 'Este template suporta vídeo no cabeçalho' : 'Este template suporta imagem no cabeçalho'"
              :state="validacao.image"
            >
              <div
                v-if="previewImagem || previewVideo"
                class="media-preview mb-2"
              >
                <!-- Preview de Imagem -->
                <img
                  v-if="previewImagem && !previewVideo"
                  :src="previewImagem"
                  alt="Preview"
                >

                <!-- Preview de Vídeo -->
                <video
                  v-if="previewVideo"
                  controls
                >
                  <source
                    :src="previewVideo"
                    type="video/mp4"
                  >
                  Seu navegador não suporta a tag de vídeo.
                </video>

                <b-button
                  variant="danger"
                  size="sm"
                  class="remove-image-btn"
                  @click="removerMidia"
                >
                  <feather-icon
                    icon="XIcon"
                    size="14"
                  />
                </b-button>
              </div>

              <div
                v-else
                class="upload-area"
                @click="$refs.fileInput.click()"
              >
                <feather-icon
                  icon="UploadCloudIcon"
                  size="48"
                  class="text-muted mb-2"
                />
                <p class="text-muted mb-0">
                  Clique para selecionar {{ templateTipoMidia === 'VIDEO' ? 'um vídeo' : 'uma imagem ou vídeo' }}
                </p>
                <small class="text-muted">
                  <template v-if="templateTipoMidia === 'VIDEO'">
                    <strong>Vídeo:</strong> MP4, MOV, AVI - Máx. 16MB
                  </template>
                  <template v-else>
                    <strong>Imagem:</strong> JPG, PNG, GIF - Máx. 5MB<br>
                    <strong>Vídeo:</strong> MP4, MOV, AVI - Máx. 16MB
                  </template>
                </small>
              </div>

              <input
                ref="fileInput"
                type="file"
                :accept="templateTipoMidia === 'VIDEO' ? 'video/mp4,video/quicktime,video/x-msvideo' : 'image/*,video/mp4,video/quicktime,video/x-msvideo'"
                style="display: none"
                @change="handleMediaUpload"
              >

              <b-progress
                v-if="uploadando"
                :value="progressoUpload"
                :max="100"
                show-progress
                animated
                class="mt-2"
              />
              <b-form-invalid-feedback v-if="validacao.image === false">
                É necessário selecionar uma {{ templateTipoMidia === 'VIDEO' ? 'vídeo' : 'imagem ou vídeo' }} para este template
              </b-form-invalid-feedback>
            </b-form-group>

            <!-- Inputs de arquivo do carrossel (ocultos; upload via preview do WhatsApp) -->
            <div
              v-if="isTemplateCarrossel"
              style="display: none;"
            >
              <input
                v-for="(card, index) in carouselCards"
                :key="index"
                :ref="`cardFileInput${index}`"
                type="file"
                accept="image/jpeg,image/png,image/gif"
                @change="handleCardImageUpload(index, $event)"
              >
            </div>
          </div>

          <!-- Step 3: Audiência -->
          <div
            v-show="stepAtual === 2"
            class="step-content"
          >
            <div class="step-header mb-3">
              <h5 class="mb-1">
                Audiência
              </h5>
              <p class="text-muted small mb-0">
                Escolha ou crie uma audiência para quem receberá a campanha
              </p>
            </div>

            <!-- Se não tem audiências disponíveis -->
            <div
              v-if="audienceOptions.length === 0 && !carregandoAudiencias"
              class="no-audiences-container"
            >
              <div class="no-audiences-content">
                <feather-icon
                  icon="UsersIcon"
                  size="48"
                  class="text-primary mb-3"
                />
                <h5 class="mb-2">
                  Nenhuma Audiência Disponível
                </h5>
                <p class="text-muted mb-3">
                  Você precisa criar pelo menos uma audiência antes de criar campanhas.<br>
                  As audiências definem quais clientes receberão sua campanha.
                </p>
                <b-button
                  variant="primary"
                  @click="irParaAudiencias"
                >
                  <feather-icon
                    icon="PlusIcon"
                    size="16"
                    class="mr-50"
                  />
                  Criar Audiência
                </b-button>
              </div>
            </div>

            <!-- Seletor de Audiência em Cards -->
            <b-form-group
              v-else
              label="Audiência"
              label-for="audience_id"
              :state="validacao.audience_id"
            >
              <div class="audience-selector-wrapper">
                <div
                  v-if="!form.audience_id"
                  class="audience-action-cards"
                >
                  <div
                    class="audience-action-card audience-action-select"
                    @click="abrirModalAudiencias"
                  >
                    <div class="action-icon-wrapper bg-light-primary">
                      <feather-icon
                        icon="UsersIcon"
                        size="28"
                        class="text-primary"
                      />
                    </div>
                    <h6 class="mb-1">
                      Selecionar Audiência
                    </h6>
                    <p class="text-muted small mb-0">
                      Escolha uma audiência já criada
                    </p>
                  </div>

                  <div
                    class="audience-action-card audience-action-create"
                    @click="irParaAudiencias"
                  >
                    <div class="action-icon-wrapper bg-light-success">
                      <feather-icon
                        icon="PlusCircleIcon"
                        size="28"
                        class="text-success"
                      />
                    </div>
                    <h6 class="mb-1">
                      Criar Nova Audiência
                    </h6>
                    <p class="text-muted small mb-0">
                      Segmente seus clientes por critérios
                    </p>
                  </div>
                </div>
                <div
                  v-else
                  class="audience-selected"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="CheckCircleIcon"
                        size="20"
                        class="text-success mr-2"
                      />
                      <div>
                        <strong>{{ audienciaSelecionadaNome }}</strong>
                        <br>
                        <small class="text-muted">Audiência selecionada</small>
                      </div>
                    </div>
                    <div>
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="abrirModalAudiencias"
                      >
                        <feather-icon
                          icon="RefreshCwIcon"
                          size="14"
                          class="mr-50"
                        />
                        Trocar
                      </b-button>
                      <b-button
                        variant="outline-danger"
                        size="sm"
                        class="ml-1"
                        @click="removerAudiencia"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          size="14"
                        />
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <b-form-invalid-feedback :state="validacao.audience_id">
                Audiência é obrigatória
              </b-form-invalid-feedback>
            </b-form-group>

            <!-- Modal de Seleção de Audiências -->
            <b-modal
              v-model="modalAudienciasVisivel"
              title="Selecionar Audiência"
              size="lg"
              scrollable
              body-class="modal-templates-body"
              header-class="modal-templates-header"
              footer-class="modal-templates-footer"
              dialog-class="modal-audiencias-dialog"
            >

              <p class="text-muted small mb-4 text-center">
                Clique em uma audiência abaixo para selecioná-la.
              </p>

              <!-- Loading -->
              <div
                v-if="carregandoAudiencias"
                class="text-center py-5"
              >
                <b-spinner
                  variant="primary"
                  style="width: 3rem; height: 3rem;"
                />
                <p class="mt-2 text-muted">
                  Carregando audiências...
                </p>
              </div>

              <!-- Estado vazio -->
              <div
                v-else-if="!audienceOptions || audienceOptions.length === 0"
                class="text-center py-5"
              >
                <feather-icon
                  icon="UsersIcon"
                  size="64"
                  class="text-warning mb-3"
                />
                <h5 class="text-muted">
                  Nenhuma audiência disponível
                </h5>
                <p class="text-muted small">
                  Crie audiências para utilizá-las em campanhas.
                </p>
              </div>

              <!-- Grid de Audiências -->
              <div
                v-else
                class="templates-grid"
              >
                <div
                  v-for="audience in audienceOptions"
                  :key="audience.value || audience.id"
                  class="template-card"
                  :class="{ 'template-selected': audienciaModalSelecionada === (audience.value || audience.id) }"
                  @click="selecionarAudienciaModal(audience)"
                >
                  <div class="template-card-header">
                    <div class="template-icon">
                      <feather-icon
                        :icon="audienciaModalSelecionada === (audience.value || audience.id) ? 'CheckCircleIcon' : 'UsersIcon'"
                        size="20"
                        :class="audienciaModalSelecionada === (audience.value || audience.id) ? 'text-success' : 'text-primary'"
                      />
                    </div>
                    <div class="template-name">
                      {{ audience.text || audience.name || 'Audiência' }}
                    </div>
                  </div>
                  <div class="template-card-body">
                    <div class="template-preview">
                      <div
                        v-if="audience.count"
                        class="d-flex align-items-center mb-1"
                      >
                        <feather-icon
                          icon="UsersIcon"
                          size="14"
                          class="mr-1 text-muted"
                        />
                        <span>{{ audience.count }} contatos</span>
                      </div>
                      <div
                        v-if="audience.description"
                        class="text-muted"
                      >
                        {{ audience.description }}
                      </div>
                      <div
                        v-else
                        class="text-muted"
                      >
                        Audiência segmentada
                      </div>
                    </div>
                  </div>
                  <div class="template-card-footer">
                    <small class="text-muted">
                      <feather-icon
                        icon="CheckIcon"
                        size="12"
                        class="mr-1"
                      />
                      Disponível
                    </small>
                  </div>
                </div>
              </div>

              <template #modal-footer>
                <div class="modal-actions">
                  <b-button
                    variant="outline-primary"
                    @click="irParaAudiencias"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      size="16"
                      class="mr-1"
                    />
                    Criar Audiência
                  </b-button>
                  <b-button
                    variant="outline-secondary"
                    @click="modalAudienciasVisivel = false"
                  >
                    <feather-icon
                      icon="XIcon"
                      size="16"
                      class="mr-1"
                    />
                    Cancelar
                  </b-button>
                  <b-button
                    variant="primary"
                    :disabled="!audienciaModalSelecionada"
                    @click="confirmarAudiencia"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      size="16"
                      class="mr-1"
                    />
                    Confirmar Seleção
                  </b-button>
                </div>
              </template>
            </b-modal>
          </div>

          <!-- Step 4: Agendamento -->
          <div
            v-show="stepAtual === 3"
            class="step-content"
          >
            <div class="step-header mb-3">
              <h5 class="mb-1">
                Configurações
              </h5>
              <p class="text-muted small mb-0">
                Nomeie sua campanha e defina as configurações
              </p>
            </div>

            <!-- Nome da Campanha -->
            <b-form-group
              label="Nome da Campanha"
              label-for="name"
              :state="validacao.name"
            >
              <b-form-input
                id="name"
                v-model="form.name"
                placeholder="Ex: Black Friday 2025"
                :state="validacao.name"
                required
              />
              <b-form-invalid-feedback>
                Nome é obrigatório (mínimo 3 caracteres)
              </b-form-invalid-feedback>
            </b-form-group>

            <!-- Descrição -->
            <b-form-group
              label="Descrição"
              label-for="description"
            >
              <b-form-textarea
                id="description"
                v-model="form.description"
                placeholder="Descreva o objetivo da campanha..."
                rows="2"
              />
            </b-form-group>

            <b-form-group
              label="Cupom"
              label-for="coupon_code"
              description="Opcional. Identificador do cupom usado na atribuição de conversões (máx. 100 caracteres)."
            >
              <b-form-input
                id="coupon_code"
                v-model="form.coupon_code"
                placeholder="Ex: BLACKFRIDAY20"
                maxlength="100"
                trim
              />
            </b-form-group>

            <!-- Quando disparar a campanha -->
            <b-form-group
              label="Quando deseja disparar a campanha?"
              :state="validacao.send_date"
            >
              <!-- Card que mostra o agendamento selecionado ou botão para abrir modal -->
              <div
                v-if="!tipoEnvio"
                class="schedule-selector-card"
                @click="abrirModalAgendamento"
              >
                <div class="d-flex align-items-center">
                  <div class="schedule-icon bg-light-primary">
                    <feather-icon
                      icon="CalendarIcon"
                      size="24"
                      class="text-primary"
                    />
                  </div>
                  <div class="ml-3">
                    <h6 class="mb-0">
                      Definir agendamento
                    </h6>
                    <small class="text-muted">Clique para escolher quando disparar</small>
                  </div>
                </div>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="20"
                  class="text-muted"
                />
              </div>

              <!-- Card mostrando agendamento já definido -->
              <div
                v-else
                class="schedule-selected-card"
                :class="{ 'immediate': tipoEnvio === 'imediato', 'scheduled': tipoEnvio === 'agendado' }"
              >
                <div class="d-flex align-items-center">
                  <div
                    class="schedule-icon"
                    :class="tipoEnvio === 'imediato' ? 'bg-light-success' : 'bg-light-primary'"
                  >
                    <feather-icon
                      :icon="tipoEnvio === 'imediato' ? 'ZapIcon' : 'CalendarIcon'"
                      size="24"
                      :class="tipoEnvio === 'imediato' ? 'text-success' : 'text-primary'"
                    />
                  </div>
                  <div class="ml-3">
                    <h6 class="mb-0">
                      {{ tipoEnvio === 'imediato' ? 'Ativar Imediatamente' : 'Agendado' }}
                    </h6>
                    <small :class="tipoEnvio === 'imediato' ? 'text-success' : 'text-primary'">
                      <feather-icon
                        icon="ClockIcon"
                        size="12"
                        class="mr-1"
                      />
                      {{ tipoEnvio === 'imediato' ? getHorarioEnvioImediato() : formatarDataAgendada() }}
                    </small>
                  </div>
                </div>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="abrirModalAgendamento"
                >
                  <feather-icon
                    icon="EditIcon"
                    size="14"
                    class="mr-50"
                  />
                  Alterar
                </b-button>
              </div>

              <b-form-invalid-feedback
                v-if="!tipoEnvio && tentouSalvar"
                :state="false"
              >
                Selecione quando deseja disparar a campanha
              </b-form-invalid-feedback>
            </b-form-group>

            <!-- Modal de Agendamento -->
            <b-modal
              v-model="modalAgendamentoVisivel"
              title="Quando disparar a campanha?"
              centered
              hide-footer
              size="md"
            >
              <div class="schedule-modal-content">
                <!-- Opção: Ativar Imediatamente -->
                <div
                  class="schedule-option-card"
                  :class="{ 'selected': tipoEnvioTemp === 'imediato' }"
                  @click="selecionarTipoEnvioTemp('imediato')"
                >
                  <div class="d-flex align-items-center">
                    <div class="schedule-option-icon bg-light-success">
                      <feather-icon
                        icon="ZapIcon"
                        size="28"
                        class="text-success"
                      />
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1">
                        Ativar Imediatamente
                      </h6>
                      <p class="text-muted small mb-0">
                        A campanha será enviada em <strong>10 minutos</strong>
                      </p>
                      <div
                        v-if="tipoEnvioTemp === 'imediato'"
                        class="mt-1"
                      >
                        <small class="text-success font-weight-bold">
                          <feather-icon
                            icon="ClockIcon"
                            size="12"
                            class="mr-1"
                          />
                          Envio: {{ getHorarioEnvioImediato() }}
                        </small>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="tipoEnvioTemp === 'imediato'"
                    class="schedule-option-check"
                  >
                    <feather-icon
                      icon="CheckCircleIcon"
                      size="24"
                      class="text-success"
                    />
                  </div>
                </div>

                <!-- Opção: Agendar para depois -->
                <div
                  class="schedule-option-card"
                  :class="{ 'selected': tipoEnvioTemp === 'agendado' }"
                  @click="selecionarTipoEnvioTemp('agendado')"
                >
                  <div class="d-flex align-items-center">
                    <div class="schedule-option-icon bg-light-primary">
                      <feather-icon
                        icon="CalendarIcon"
                        size="28"
                        class="text-primary"
                      />
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1">
                        Agendar para depois
                      </h6>
                      <p class="text-muted small mb-0">
                        Escolha a data e hora do envio
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="tipoEnvioTemp === 'agendado'"
                    class="schedule-option-check"
                  >
                    <feather-icon
                      icon="CheckCircleIcon"
                      size="24"
                      class="text-primary"
                    />
                  </div>
                </div>

                <!-- Campos de Data e Hora (só aparecem quando "Agendar" está selecionado) -->
                <transition name="slide-fade">
                  <div
                    v-if="tipoEnvioTemp === 'agendado'"
                    class="schedule-fields mt-3"
                  >
                    <b-row>
                      <b-col cols="6">
                        <b-form-group
                          label="Data"
                          label-for="modal_send_date"
                          class="mb-2"
                        >
                          <b-form-input
                            id="modal_send_date"
                            v-model="dataEnvioTemp"
                            type="date"
                            :min="dataMinima"
                            required
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group
                          label="Hora"
                          label-for="modal_send_time"
                          class="mb-2"
                        >
                          <b-form-input
                            id="modal_send_time"
                            v-model="horaEnvioTemp"
                            type="time"
                            required
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Alerta de erro quando data é inválida -->
                    <b-alert
                      v-if="mostrarErroDataModal"
                      show
                      variant="danger"
                      class="mb-0 p-2"
                    >
                      <div class="d-flex align-items-start">
                        <feather-icon
                          icon="AlertCircleIcon"
                          size="16"
                          class="mr-2 mt-0"
                        />
                        <div>
                          <strong>Data inválida!</strong>
                          <div class="small">
                            A data e hora de envio devem ser pelo menos <strong>10 minutos à frente</strong> do horário atual.<br>
                            <span class="text-muted">
                              Horário atual: {{ getHorarioAtual() }}<br>
                              Mínimo permitido: {{ getHorarioMinimo() }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </b-alert>
                  </div>
                </transition>

                <!-- Botões do Modal -->
                <div class="d-flex justify-content-end mt-4">
                  <b-button
                    variant="outline-secondary"
                    class="mr-2"
                    @click="modalAgendamentoVisivel = false"
                  >
                    Cancelar
                  </b-button>
                  <b-button
                    variant="primary"
                    :disabled="!podeConfirmarAgendamento"
                    @click="confirmarAgendamento"
                  >
                    Confirmar
                  </b-button>
                </div>
              </div>
            </b-modal>

            <!-- UTM Campaign (somente leitura, extraído do template) -->
            <b-form-group v-if="form.template_name">
              <template #label>
                <div class="d-flex align-items-center">
                  <span>UTM Campaign</span>
                  <feather-icon
                    v-b-tooltip.hover.top="'Extraído automaticamente do link do template selecionado. Usado para rastrear conversões no Google Analytics.'"
                    icon="HelpCircleIcon"
                    size="16"
                    class="ml-50 text-muted cursor-pointer"
                  />
                </div>
              </template>
              <div
                v-if="form.utm_campaign"
                class="attribution-window-info"
              >
                <div class="d-flex align-items-center">
                  <feather-icon
                    icon="LinkIcon"
                    size="18"
                    class="text-primary mr-2"
                  />
                  <div>
                    <strong>{{ form.utm_campaign }}</strong>
                    <br>
                    <small class="text-muted">Extraído automaticamente do link do template</small>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="attribution-window-info"
              >
                <div class="d-flex align-items-center">
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="18"
                    class="text-warning mr-2"
                  />
                  <div>
                    <span class="text-muted">Não há UTM neste template</span>
                    <br>
                  </div>
                </div>
              </div>
            </b-form-group>

            <!-- Janela de Atribuição (somente leitura) -->
            <b-form-group
              label-for="attribution_window_hours"
            >
              <template #label>
                <div class="d-flex align-items-center">
                  <span>Janela de Atribuição</span>
                  <feather-icon
                    v-b-tooltip.hover.top="'A janela de atribuição define o período de tempo após o envio da mensagem em que uma compra será contabilizada como conversão da campanha. Qualquer compra feita pelo cliente em até 7 dias após receber a mensagem será atribuída a esta campanha.'"
                    icon="HelpCircleIcon"
                    size="16"
                    class="ml-50 text-muted cursor-pointer"
                  />
                </div>
              </template>
              <div class="attribution-window-info">
                <div class="d-flex align-items-center">
                  <feather-icon
                    icon="ClockIcon"
                    size="18"
                    class="text-primary mr-2"
                  />
                  <div>
                    <strong>168 horas (7 dias)</strong>
                    <br>
                    <small class="text-muted">Conversões realizadas neste período serão atribuídas a esta campanha</small>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>
        </b-form>
      </b-col>

      <!-- Coluna do Preview (Desktop) - oculta no passo 1 -->
      <b-col
        v-show="stepAtual > 0"
        cols="12"
        lg="5"
        class="preview-column"
      >
        <div
          v-if="templateSelecionado"
          class="preview-container"
        >
          <h6 class="preview-title mb-3">
            Preview do WhatsApp
          </h6>
          <whats-app-preview
            :template="templateSelecionado"
            :custom-image="imagemParaPreview"
            :carousel-cards="carouselCards"
            @click-card="abrirUploadCard"
          />
        </div>
        <div
          v-else
          class="preview-placeholder"
        >
          <feather-icon
            icon="SmartphoneIcon"
            size="48"
            class="text-muted mb-2"
          />
          <p class="text-muted mb-0">
            Selecione um template para visualizar o preview
          </p>
        </div>
      </b-col>
    </b-row>

    <!-- Footer com botões de navegação -->
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button
          v-if="stepAtual > 0"
          variant="outline-secondary"
          @click="voltarStep"
        >
          <feather-icon
            icon="ChevronLeftIcon"
            size="16"
            class="mr-50"
          />
          Voltar
        </b-button>
        <div v-else />

        <div class="d-flex gap-2">
          <b-button
            variant="secondary"
            @click="fecharModal"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            :disabled="!podeAvancar || uploadando || salvamentoEdicaoBloqueado"
            @click="avancarOuSalvar"
          >
            <b-spinner
              v-if="salvando"
              small
              class="mr-1"
            />
            <template v-if="stepAtual < steps.length - 1">
              Avançar
              <feather-icon
                icon="ChevronRightIcon"
                size="16"
                class="ml-50"
              />
            </template>
            <template v-else>
              {{ campanhaEdicao ? 'Salvar Alterações' : 'Criar Campanha' }}
            </template>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormSelectOption,
  BFormInvalidFeedback,
  BRow,
  BCol,
  BButton,
  BProgress,
  BSpinner,
  BBadge,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import ModalSelecaoTemplates from '@core/components/modal-selecao-templates/ModalSelecaoTemplates.vue'
import { buscarTemplates, buscarAudiencias, uploadImagem } from '@/functions/basics/campaign-oficial'
import { DraftCache, formatDraftAge } from '@/utils/draftCache'
import WhatsAppPreview from './WhatsAppPreview.vue'

export default {
  name: 'ModalNovaCampanha',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BButton,
    BProgress,
    BSpinner,
    BBadge,
    BAlert,
    FeatherIcon,
    WhatsAppPreview,
    ModalSelecaoTemplates,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    campanhaEdicao: {
      type: Object,
      default: null,
    },
    /** Em modo edição, se false, bloqueia salvar no último passo (ex.: menos de 10 min para o envio). */
    podeSalvarEdicao: {
      type: Boolean,
      default: true,
    },
    storeUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      stepAtual: 0,
      steps: [
        { label: 'Como Funciona', key: 'info' },
        { label: 'Template', key: 'template' },
        { label: 'Audiência', key: 'audience' },
        { label: 'Configurações', key: 'schedule' },
      ],
      mostrarErroData: false,
      tipoEnvio: null, // 'imediato' ou 'agendado'
      form: {
        name: '',
        template_name: null,
        audience_id: null,
        image_url: '',
        send_date: '',
        description: '',
        attribution_window_hours: 168,
        utm_campaign: '',
        coupon_code: '',
      },
      dataEnvio: '',
      horaEnvio: '',
      previewImagem: null,
      previewVideo: null,
      videoThumbnail: null,
      imageFile: null,
      templateMediaType: null,
      uploadando: false,
      salvando: false,
      progressoUpload: 0,
      carregandoTemplates: false,
      carregandoAudiencias: false,
      templates: [],
      templateOptions: [],
      audienceOptions: [],
      tentouSalvar: false,
      nomeAnterior: '',
      modalTemplatesVisivel: false,
      modalAudienciasVisivel: false,
      modalAgendamentoVisivel: false,
      tipoEnvioTemp: null,
      dataEnvioTemp: '',
      horaEnvioTemp: '',
      mostrarErroDataModal: false,
      audienciaModalSelecionada: null,
      audienciaModalSelecionadaObj: null,
      // Carrossel
      isCarouselTemplate: false,
      carouselCards: [],
      // Sistema de Rascunho
      draftCache: null,
      salvandoRascunho: false,
      campanhaSalva: false,
    }
  },
  computed: {
    tituloModal() {
      if (this.campanhaEdicao) return 'Editar Campanha'
      return `Nova Campanha - ${this.steps[this.stepAtual].label}`
    },
    salvamentoEdicaoBloqueado() {
      if (!this.campanhaEdicao) return false
      const ultimo = this.stepAtual === this.steps.length - 1
      return ultimo && this.podeSalvarEdicao === false
    },
    podeConfirmarAgendamento() {
      if (!this.tipoEnvioTemp) return false
      if (this.tipoEnvioTemp === 'imediato') return true
      return !!(this.dataEnvioTemp && this.horaEnvioTemp)
    },
    podeAvancar() {
      if (this.stepAtual === 0) {
        // Step 1: Como funciona - sempre pode avançar
        return true
      }

      if (this.stepAtual === 1) {
        // Step 2: Template
        const temTemplate = !!this.form.template_name
        if (!temTemplate) return false

        if (this.templatePrecisaMidia) {
          if (this.isTemplateCarrossel) {
            return this.carouselCards.length > 0
                   && this.carouselCards.every(card => card.imageFile || card.imageUrl)
          }
          return !!(this.imageFile || this.previewImagem || this.previewVideo || this.form.image_url)
        }

        return true
      }

      if (this.stepAtual === 2) {
        // Step 3: Audiência
        return !!this.form.audience_id
      }

      if (this.stepAtual === 3) {
        // Step 4: Agendamento + Nome
        return this.form.name
               && this.form.name.length >= 3
               && this.tipoEnvio // Deve ter selecionado imediato ou agendado
               && this.form.send_date
               && this.dataEnvio
               && this.horaEnvio
               && this.validarDataEnvio()
               && this.form.attribution_window_hours >= 2
               && this.form.attribution_window_hours <= 168
      }

      return false
    },
    validacao() {
      if (!this.tentouSalvar) {
        return {
          name: null,
          template_name: null,
          audience_id: null,
          send_date: null,
          attribution_window_hours: null,
          image: null,
        }
      }

      // Validar se send_date é maior que a data/hora atual
      const dataEnvioValida = this.validarDataEnvio()

      // Validar se template com imagem tem imagem selecionada
      const imagemValida = this.validarImagemTemplate()

      return {
        name: this.form.name && this.form.name.length >= 3,
        template_name: !!this.form.template_name,
        audience_id: !!this.form.audience_id,
        send_date: !!this.form.send_date && dataEnvioValida,
        attribution_window_hours:
          this.form.attribution_window_hours >= 2
          && this.form.attribution_window_hours <= 168,
        utm_campaign: true, // UTM Campaign não é obrigatório
        coupon_code: true, // Cupom não é obrigatório
        image: imagemValida,
      }
    },
    formularioValido() {
      // Botão habilitado apenas quando os campos básicos estiverem preenchidos
      // As validações de data futura e imagem serão feitas no método salvarCampanha()
      return (
        this.form.name
        && this.form.template_name
        && this.form.audience_id
        && this.form.send_date
        && this.dataEnvio
        && this.horaEnvio
      )
    },
    templateSelecionado() {
      if (!this.form.template_name) return null
      return this.templates.find(t => t.name === this.form.template_name)
    },
    templatePrecisaMidia() {
      if (!this.templateSelecionado) {
        console.log('❌ Nenhum template selecionado')
        return false
      }

      console.log('🔍 Verificando template:', this.templateSelecionado.name)
      console.log('📋 Estrutura completa:', this.templateSelecionado)

      // Verificar na estrutura com components (padrão WhatsApp)
      if (this.templateSelecionado.components && this.templateSelecionado.components.length > 0) {
        console.log('📦 Components encontrados:', this.templateSelecionado.components)
        const headerComponent = this.templateSelecionado.components.find(c => c.type === 'HEADER')

        if (headerComponent) {
          console.log('📌 Header encontrado:', headerComponent)
          console.log('🖼️ Format:', headerComponent.format)
          const precisaMidia = headerComponent.format === 'IMAGE' || headerComponent.format === 'VIDEO'
          console.log(precisaMidia ? `✅ Template precisa de mídia (${headerComponent.format})!` : `✅ Template tem HEADER mas tipo ${headerComponent.format} - NÃO precisa de mídia`)
          return precisaMidia
        }
        // ✅ Sem HEADER = sem mídia necessária
        console.log('✅ Template sem HEADER - NÃO precisa de mídia')
        return false
      }

      // Verificar na estrutura antiga (fallback)
      if (this.templateSelecionado.header) {
        console.log('📌 Header (estrutura antiga):', this.templateSelecionado.header)
        const precisaMidia = this.templateSelecionado.header.format === 'IMAGE' || this.templateSelecionado.header.format === 'VIDEO'
        console.log(precisaMidia ? `✅ Template precisa de mídia (${this.templateSelecionado.header.format}) (estrutura antiga)!` : '✅ Template tem header mas NÃO precisa de mídia (estrutura antiga)')
        return precisaMidia
      }

      // ✅ Sem header em nenhuma estrutura = sem mídia necessária
      console.log('✅ Nenhuma estrutura de header encontrada - template NÃO precisa de mídia')
      return false
    },
    templateTipoMidia() {
      if (!this.templateSelecionado) return null

      // Verificar na estrutura com components (padrão WhatsApp)
      if (this.templateSelecionado.components && this.templateSelecionado.components.length > 0) {
        const headerComponent = this.templateSelecionado.components.find(c => c.type === 'HEADER')
        if (headerComponent && (headerComponent.format === 'IMAGE' || headerComponent.format === 'VIDEO')) {
          return headerComponent.format
        }
      }

      // Verificar na estrutura antiga (fallback)
      if (this.templateSelecionado.header && (this.templateSelecionado.header.format === 'IMAGE' || this.templateSelecionado.header.format === 'VIDEO')) {
        return this.templateSelecionado.header.format
      }

      return null
    },
    templateTemImagem() {
      // Mantido para compatibilidade com código existente
      return this.templateTipoMidia === 'IMAGE'
    },
    // 🆕 Verifica se a mídia foi carregada do template (download automático)
    midiaCarregadaDoTemplate() {
      // Agora a mídia do template é baixada automaticamente e colocada em imageFile
      // Então verificamos se temos imageFile E templateMediaType definido
      return !!(this.imageFile && this.templateMediaType)
    },
    // 🆕 Verifica se tem mídia para exibir no formulário (local ou do template)
    temMidiaParaExibir() {
      return !!(this.previewImagem || this.previewVideo || this.form.image_url)
    },
    // 🆕 Retorna a imagem para exibir no formulário de mídia
    imagemParaExibirNoForm() {
      // Prioridade: preview local > URL do template
      return this.previewImagem || this.form.image_url
    },
    imagemParaPreview() {
      // Se houver vídeo, usar a thumbnail do vídeo
      if (this.previewVideo && this.videoThumbnail) {
        return this.videoThumbnail
      }
      // Caso contrário, usar a imagem (preview local ou URL do template)
      return this.previewImagem || this.form.image_url
    },
    audienciaSelecionadaNome() {
      if (!this.form.audience_id || !this.audienceOptions) return ''
      const audience = this.audienceOptions.find(
        a => (a.value || a.id) === this.form.audience_id,
      )
      return audience ? (audience.text || audience.name || 'Audiência') : ''
    },
    dataMinima() {
      const hoje = new Date()
      const ano = hoje.getFullYear()
      const mes = String(hoje.getMonth() + 1).padStart(2, '0')
      const dia = String(hoje.getDate()).padStart(2, '0')
      return `${ano}-${mes}-${dia}`
    },
    // 🎠 Verificar se o template é de carrossel
    isTemplateCarrossel() {
      if (!this.templateSelecionado) return false

      if (this.templateSelecionado.components && Array.isArray(this.templateSelecionado.components)) {
        return this.templateSelecionado.components.some(comp => comp.type === 'CAROUSEL')
      }

      return false
    },
    // 🎠 Extrair cards do template de carrossel
    carrosselCards() {
      if (!this.isTemplateCarrossel) return []

      const carouselComponent = this.templateSelecionado.components.find(c => c.type === 'CAROUSEL')
      if (!carouselComponent?.cards) return []

      return carouselComponent.cards.map((card, index) => {
        // Extrair URL da imagem do header example
        const headerComponent = card.components?.find(c => c.type === 'HEADER')
        const imageUrl = headerComponent?.example?.header_handle?.[0] || null

        // Extrair URL do botão e parâmetro do exemplo
        const buttonComponent = card.components?.find(c => c.type === 'BUTTONS')
        const button = buttonComponent?.buttons?.[0]
        const buttonUrl = button?.url || ''
        const buttonExample = button?.example?.[0] || '' // Parâmetro do exemplo

        return {
          index,
          imageUrl, // 🆕 URL da imagem já vem do template
          imageFile: null, // Só será usado se o usuário substituir
          previewImage: imageUrl, // 🆕 Usar URL do template como preview inicial
          buttonParam: buttonExample, // 🆕 Parâmetro vem do exemplo do template
          buttonUrlTemplate: buttonUrl, // Ex: "https://loja.com/{{1}}"
          buttonUrlFull: buttonUrl.replace('{{1}}', buttonExample), // URL completa para exibição
        }
      })
    },
  },
  watch: {
    value(visivel) {
      if (visivel) {
        this.stepAtual = 0
        this.mostrarErroData = false
        this.campanhaSalva = false
        this.inicializarFormulario()
        this.carregarTemplates()
        this.carregarAudiencias()

        // Inicializar cache e verificar rascunho
        this.inicializarCache()
        setTimeout(() => {
          this.verificarRascunho()
        }, 500)
      } else {
        // Ao fechar: salvar se tiver dados
        this.salvarRascunhoAoFechar()
      }
    },
    'form.template_name': function (novoTemplate) {
      if (novoTemplate && this.isTemplateCarrossel) {
        console.log('🎠 Template de carrossel detectado:', novoTemplate)
        this.carouselCards = this.carrosselCards.map(card => ({ ...card }))
      } else {
        this.carouselCards = []
      }
      // Auto-save quando template mudar
      this.salvarRascunhoDebounced()
    },
    dataEnvio() {
      this.atualizarDataEnvio()
      this.validarDataTempoReal()
    },
    horaEnvio() {
      this.atualizarDataEnvio()
      this.validarDataTempoReal()
    },
    'form.name': function (novoNome) {
      this.nomeAnterior = novoNome
      // Auto-save quando nome mudar
      this.salvarRascunhoDebounced()
    },
    // Auto-save: observa mudanças no form
    form: {
      handler() {
        if (this.value) {
          this.salvarRascunhoDebounced()
        }
      },
      deep: true,
    },
    stepAtual() {
      if (this.value) {
        this.salvarRascunhoDebounced()
      }
    },
  },
  methods: {
    irParaTemplates() {
      const { href } = this.$router.resolve('/templates')
      window.open(href, '_blank')
    },

    irParaAudiencias() {
      const { href } = this.$router.resolve({ name: 'audiencia', params: { uuid: this.storeUuid } })
      window.open(href, '_blank')
    },

    irParaStep(index) {
      // Só permite ir para steps anteriores ou para o próximo se validado
      if (index < this.stepAtual) {
        this.stepAtual = index
      } else if (index === this.stepAtual + 1 && this.podeAvancar) {
        this.stepAtual = index
      }
    },

    voltarStep() {
      if (this.stepAtual > 0) {
        this.stepAtual--
      }
    },

    avancarOuSalvar() {
      // Se não pode avançar, não faz nada
      if (!this.podeAvancar) {
        this.tentouSalvar = true

        // Mensagem específica por step
        if (this.stepAtual === 1) {
          if (!this.form.template_name) {
            this.$bvToast.toast('Selecione um template para a campanha', {
              title: 'Template obrigatório',
              variant: 'warning',
              solid: true,
            })
          } else if (this.templatePrecisaMidia && !this.validarImagemTemplate()) {
            const tipoMidia = this.templateTipoMidia === 'VIDEO' ? 'vídeo' : 'imagem'
            this.$bvToast.toast(`Adicione uma ${tipoMidia} para este template`, {
              title: 'Mídia obrigatória',
              variant: 'warning',
              solid: true,
            })
          }
        } else if (this.stepAtual === 2) {
          // Step 3: Audiência
          if (!this.form.audience_id) {
            this.$bvToast.toast('Selecione uma audiência para a campanha', {
              title: 'Audiência obrigatória',
              variant: 'warning',
              solid: true,
            })
          }
        } else if (this.stepAtual === 3) {
          // Step 4: Agendamento + Nome
          if (!this.form.name || this.form.name.length < 3) {
            this.$bvToast.toast('Preencha o nome da campanha (mínimo 3 caracteres)', {
              title: 'Nome obrigatório',
              variant: 'warning',
              solid: true,
            })
          } else if (!this.tipoEnvio) {
            this.$bvToast.toast('Escolha se deseja ativar imediatamente ou agendar para depois', {
              title: 'Selecione quando disparar',
              variant: 'warning',
              solid: true,
            })
          } else if (!this.form.send_date || !this.dataEnvio || !this.horaEnvio) {
            this.$bvToast.toast('Defina a data e hora de envio da campanha', {
              title: 'Data obrigatória',
              variant: 'warning',
              solid: true,
            })
          } else if (!this.validarDataEnvio()) {
            this.$bvToast.toast('A data de envio deve ser pelo menos 10 minutos à frente', {
              title: 'Data inválida',
              variant: 'warning',
              solid: true,
            })
          }
        }

        return
      }

      // Se não é o último step, avança
      if (this.stepAtual < this.steps.length - 1) {
        this.stepAtual++
      } else {
        // Se é o último step, salva a campanha
        this.salvarCampanha()
      }
    },

    // Abrir modal de seleção visual de templates
    abrirModalTemplates() {
      this.modalTemplatesVisivel = true
    },

    // Audiência: abrir modal, selecionar, confirmar, remover
    abrirModalAudiencias() {
      this.audienciaModalSelecionada = this.form.audience_id || null
      this.audienciaModalSelecionadaObj = null
      this.modalAudienciasVisivel = true
    },
    selecionarAudienciaModal(audience) {
      this.audienciaModalSelecionada = audience.value || audience.id
      this.audienciaModalSelecionadaObj = audience
    },
    confirmarAudiencia() {
      if (this.audienciaModalSelecionada) {
        this.form.audience_id = this.audienciaModalSelecionada
        this.modalAudienciasVisivel = false
      }
    },
    removerAudiencia() {
      this.form.audience_id = null
      this.audienciaModalSelecionada = null
      this.audienciaModalSelecionadaObj = null
    },

    // Callback quando um template é selecionado no modal
    onTemplateSelecionado(templateData) {
      console.log('📋 Template selecionado (dados do modal):', templateData)

      // 🆕 Limpar mídia anterior antes de carregar a nova
      this.limparMidiaAtual()

      this.form.template_name = templateData.name

      // 🆕 Buscar o template completo da lista carregada (com components)
      const templateCompleto = this.templates.find(t => t.name === templateData.name)
      console.log('📋 Template completo encontrado:', templateCompleto)

      if (templateCompleto) {
        // 🆕 Extrair header_handle para pré-carregar a mídia do template
        this.preCarregarMidiaDoTemplate(templateCompleto)

        // 🆕 Extrair utm_campaign da URL do botão
        this.extrairUtmCampaignDoTemplate(templateCompleto)
      }

      this.$bvToast.toast(`Template "${templateData.name}" selecionado!`, {
        title: 'Template Selecionado',
        variant: 'success',
        solid: true,
      })
    },

    // 🆕 Limpa a mídia atual (usada ao trocar de template)
    limparMidiaAtual() {
      this.form.image_url = ''
      this.form.utm_campaign = '' // 🆕 Limpar UTM ao trocar template
      this.previewImagem = null
      this.previewVideo = null
      this.videoThumbnail = null
      this.imageFile = null
      this.templateMediaType = null
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },

    // 🆕 Pré-carrega a mídia do template (header_handle) e faz download automático
    async preCarregarMidiaDoTemplate(templateData) {
      if (!templateData.components) {
        console.log('❌ Template sem components')
        return
      }

      // Garantir que components é um array
      const components = Array.isArray(templateData.components)
        ? templateData.components
        : Object.values(templateData.components)

      const headerComponent = components.find(c => c.type === 'HEADER')

      // ✅ Se o template não tem HEADER, não tem mídia para carregar (é normal, não é erro)
      if (!headerComponent) {
        console.log('✅ Template sem HEADER - não precisa de mídia')
        return
      }

      // ✅ Se tem HEADER mas não é de mídia (ex: TEXT), também não precisa carregar
      if (headerComponent.format !== 'IMAGE' && headerComponent.format !== 'VIDEO') {
        console.log(`✅ Template com HEADER tipo ${headerComponent.format} - não precisa de mídia`)
        return
      }

      // Verificar se tem header_handle no example
      const headerHandle = headerComponent.example?.header_handle?.[0]

      if (headerHandle) {
        console.log('🖼️ Mídia do template encontrada:', headerHandle, 'Tipo:', headerComponent.format)

        // 🆕 Salvar o tipo de mídia do template
        this.templateMediaType = headerComponent.format // 'IMAGE' ou 'VIDEO'

        // Limpar qualquer upload anterior
        this.imageFile = null
        this.previewImagem = null
        this.previewVideo = null
        this.videoThumbnail = null

        // 🆕 Fazer download automático da mídia do template
        await this.baixarMidiaDoTemplate(headerHandle, headerComponent.format)
      } else {
        console.log('ℹ️ Template com HEADER de mídia mas sem header_handle - precisa de upload manual')
      }
    },

    // 🆕 Baixa a mídia do template e converte em File para upload
    async baixarMidiaDoTemplate(url, mediaType) {
      try {
        this.uploadando = true
        this.progressoUpload = 10

        this.$bvToast.toast('Carregando mídia do template...', {
          title: 'Aguarde',
          variant: 'info',
          solid: true,
          noAutoHide: false,
          autoHideDelay: 2000,
        })

        console.log('📥 Baixando mídia do template:', url)

        // Fazer fetch da imagem/vídeo
        const response = await fetch(url)

        if (!response.ok) {
          throw new Error(`Erro ao baixar mídia: ${response.status}`)
        }

        this.progressoUpload = 50

        const blob = await response.blob()

        this.progressoUpload = 70

        // Determinar extensão e tipo MIME baseado no mediaType
        let extension; let
          mimeType
        if (mediaType === 'VIDEO') {
          extension = 'mp4'
          mimeType = 'video/mp4'
        } else {
          // Para imagem, tentar detectar do blob ou usar jpg como padrão
          extension = blob.type.includes('png') ? 'png' : 'jpg'
          mimeType = blob.type || 'image/jpeg'
        }

        // Criar nome do arquivo
        const fileName = `template_media_${Date.now()}.${extension}`

        // Converter blob para File
        const file = new File([blob], fileName, { type: mimeType })

        console.log('📦 Arquivo criado:', {
          name: file.name,
          size: file.size,
          type: file.type,
        })

        // Armazenar o arquivo para enviar junto com o FormData (mesmo fluxo do upload manual)
        this.imageFile = file

        this.progressoUpload = 90

        // Criar preview
        const reader = new FileReader()
        reader.onload = async e => {
          if (mediaType === 'VIDEO') {
            this.previewVideo = e.target.result
            this.previewImagem = null
            // Gerar thumbnail do vídeo
            await this.gerarThumbnailVideo(e.target.result)
          } else {
            this.previewImagem = e.target.result
            this.previewVideo = null
            this.videoThumbnail = null
          }
        }
        reader.readAsDataURL(file)

        this.progressoUpload = 100

        this.$bvToast.toast('Mídia do template carregada com sucesso!', {
          title: 'Mídia Pronta',
          variant: 'success',
          solid: true,
        })

        console.log('✅ Mídia do template pronta para upload')
      } catch (error) {
        console.error('❌ Erro ao baixar mídia do template:', error)

        this.$bvToast.toast('Não foi possível carregar a mídia do template. Você pode fazer upload manualmente.', {
          title: 'Erro ao carregar mídia',
          variant: 'warning',
          solid: true,
        })

        // Limpar para permitir upload manual
        this.imageFile = null
        this.templateMediaType = null
      } finally {
        this.uploadando = false
        this.progressoUpload = 0
      }
    },

    // 🆕 Extrai o utm_campaign da URL do botão do template
    extrairUtmCampaignDoTemplate(templateData) {
      if (!templateData.components) return

      const buttonsComponent = templateData.components.find(c => c.type === 'BUTTONS')
      if (!buttonsComponent || !buttonsComponent.buttons) return

      // Procurar botão com URL que contenha utm_campaign
      for (const button of buttonsComponent.buttons) {
        if (button.type === 'URL' && button.url) {
          try {
            const url = new URL(button.url)
            const utmCampaign = url.searchParams.get('utm_campaign')

            if (utmCampaign) {
              console.log('🏷️ UTM Campaign encontrado na URL do botão:', utmCampaign)
              this.form.utm_campaign = utmCampaign

              // Atualizar nomeAnterior para evitar sobrescrita pelo watcher de form.name
              this.nomeAnterior = this.form.name

              this.$bvToast.toast(`UTM Campaign "${utmCampaign}" carregado do template`, {
                title: 'UTM Carregado',
                variant: 'info',
                solid: true,
              })
              return // Encontrou, pode sair do loop
            }
          } catch (error) {
            console.warn('⚠️ Erro ao parsear URL do botão:', button.url, error)
          }
        }
      }
    },

    // Remover template selecionado
    removerTemplate() {
      this.form.template_name = null
      this.form.image_url = '' // 🆕 Limpar URL da mídia do template
      this.form.utm_campaign = '' // 🆕 Limpar UTM carregado do template
      this.previewImagem = null
      this.previewVideo = null
      this.videoThumbnail = null
      this.imageFile = null
      this.templateMediaType = null // 🆕 Limpar tipo de mídia do template

      this.$bvToast.toast('Template removido', {
        title: 'Template',
        variant: 'info',
        solid: true,
      })
    },

    validarDataEnvio() {
      if (!this.form.send_date) return false

      try {
        const dataEnvio = new Date(this.form.send_date)
        const agora = new Date()

        // Adicionar 10 minutos à data/hora atual
        const dataMinima = new Date(agora.getTime() + 10 * 60 * 1000)

        // Comparar se a data de envio é maior ou igual à data mínima (agora + 10 minutos)
        return dataEnvio >= dataMinima
      } catch (error) {
        console.error('Erro ao validar data de envio:', error)
        return false
      }
    },

    validarImagemTemplate() {
      // Se é template de carrossel, validar se todos os cards têm imagem
      if (this.isTemplateCarrossel) {
        if (this.carouselCards.length === 0) return false
        return this.carouselCards.every(card => card.imageFile || card.imageUrl)
      }

      // Se o template não precisa de mídia, não precisa validar
      if (!this.templatePrecisaMidia) return true

      // Só considerar mídia que a API aceita: File, ou URL http(s) já persistida (edição).
      // Preview em data URL sozinho NÃO basta — antes do save usamos ensureMediaFileFromPreviewIfNeeded.
      const urlHttp = u => {
        const s = u != null ? String(u).trim() : ''
        return s.length > 0 && /^https?:\/\//i.test(s)
      }
      return !!(
        this.imageFile
        || urlHttp(this.form.image_url)
        || urlHttp(this.form.video_url)
      )
    },

    /**
     * Rascunho e preview guardam data URL sem reconstruir o File.
     * Sem File, criarCampanha manda JSON sem image → image_url e whatsapp_media_id ficam nulos no back.
     */
    async ensureMediaFileFromPreviewIfNeeded() {
      if (this.isTemplateCarrossel) return true
      if (!this.templatePrecisaMidia) return true
      if (this.imageFile instanceof File) return true
      if (this.form.image_url && /^https?:\/\//i.test(String(this.form.image_url).trim())) return true
      if (this.form.video_url && /^https?:\/\//i.test(String(this.form.video_url).trim())) return true

      const fromDataUrl = async (dataUrl, baseName, kind) => {
        if (!dataUrl || typeof dataUrl !== 'string' || !dataUrl.startsWith('data:')) return false
        try {
          const res = await fetch(dataUrl)
          const blob = await res.blob()
          let mime = blob.type && blob.type !== 'application/octet-stream' ? blob.type : ''
          if (!mime) {
            mime = kind === 'video' ? 'video/mp4' : 'image/jpeg'
          }
          let ext = 'jpg'
          if (mime.includes('png')) ext = 'png'
          else if (mime.includes('gif')) ext = 'gif'
          else if (mime.includes('webp')) ext = 'webp'
          else if (mime.includes('mp4')) ext = 'mp4'
          else if (mime.includes('quicktime')) ext = 'mov'
          else if (kind === 'video') ext = 'mp4'
          const name = `${baseName}_${Date.now()}.${ext}`
          this.imageFile = new File([blob], name, { type: mime || (kind === 'video' ? 'video/mp4' : 'image/jpeg') })
          if (kind === 'image') {
            this.templateMediaType = 'IMAGE'
          } else if (kind === 'video') {
            this.templateMediaType = 'VIDEO'
          }
          return true
        } catch (e) {
          console.error('ensureMediaFileFromPreviewIfNeeded:', e)
          return false
        }
      }

      if (this.previewVideo) {
        return await fromDataUrl(this.previewVideo, 'campaign_video', 'video')
      }
      if (this.previewImagem) {
        return await fromDataUrl(this.previewImagem, 'campaign_image', 'image')
      }
      return false
    },

    async carregarTemplates() {
      this.carregandoTemplates = true
      try {
        const response = await buscarTemplates(this.storeUuid)

        // A resposta pode ser um array direto, um objeto com propriedade 'data' ou 'templates',
        // ou um objeto com chaves numéricas (ex: { "1": {...}, "2": {...} })
        let templates = []
        if (Array.isArray(response)) {
          templates = response
        } else if (response.data) {
          templates = Array.isArray(response.data) ? response.data : []
        } else if (response.templates) {
          templates = response.templates
        } else if (typeof response === 'object' && response !== null) {
          // 🆕 Se for um objeto com chaves numéricas, converter para array
          templates = Object.values(response)
          console.log('📦 Templates convertidos de objeto para array:', templates)
        }

        // 🚫 Filtrar templates que contenham botão com type 'ORDER_DETAILS' (templates de PIX)
        templates = templates.filter(template => {
          // Verificar se o template tem components (estrutura nova do WhatsApp)
          if (template.components && Array.isArray(template.components)) {
            // Procurar componente do tipo BUTTONS
            const buttonsComponent = template.components.find(comp => comp.type === 'BUTTONS')

            if (buttonsComponent && buttonsComponent.buttons && Array.isArray(buttonsComponent.buttons)) {
              // Verificar se algum botão tem type 'ORDER_DETAILS'
              const temBotaoPix = buttonsComponent.buttons.some(button => button.type === 'ORDER_DETAILS' || button.type === 'order_details')

              if (temBotaoPix) {
                console.log(`🚫 Template "${template.name}" bloqueado: contém botão PIX (ORDER_DETAILS)`)
                return false // Bloquear este template
              }
            }
          }

          return true // Permitir este template (incluindo carrossel)
        })

        this.templates = templates

        // Transformar templates em options para o select
        this.templateOptions = templates.map(template => ({
          value: template.name,
          text: template.name || 'Template sem nome',
        }))

        if (templates.length === 0) {
          this.$bvToast.toast('Nenhum template encontrado para esta loja', {
            title: 'Aviso',
            variant: 'warning',
            solid: true,
          })
        }
      } catch (error) {
        console.error('Erro ao carregar templates:', error)
        this.$bvToast.toast('Erro ao carregar templates do WhatsApp', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
        this.templateOptions = []
      } finally {
        this.carregandoTemplates = false
      }
    },

    async carregarAudiencias() {
      this.carregandoAudiencias = true
      try {
        const audiencias = await buscarAudiencias(this.storeUuid)

        this.audienceOptions = audiencias || []

        if (audiencias.length === 0) {
          this.$bvToast.toast('Nenhuma audiência encontrada para esta loja', {
            title: 'Aviso',
            variant: 'warning',
            solid: true,
          })
        }
      } catch (error) {
        console.error('Erro ao carregar audiências:', error)
        this.$bvToast.toast('Erro ao carregar audiências', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
        this.audienceOptions = []
      } finally {
        this.carregandoAudiencias = false
      }
    },

    inicializarFormulario() {
      if (this.campanhaEdicao) {
        // Editar campanha existente
        this.form = { ...this.campanhaEdicao }
        this.form.coupon_code = this.campanhaEdicao.coupon_code != null ? String(this.campanhaEdicao.coupon_code) : ''
        this.previewImagem = this.campanhaEdicao.image_url

        // Separar data e hora
        if (this.campanhaEdicao.send_date) {
          // Converter para horário de Brasília
          const data = new Date(this.campanhaEdicao.send_date)
          const dataLocal = new Date(data.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }))

          this.dataEnvio = dataLocal.toISOString().split('T')[0]
          this.horaEnvio = dataLocal.toTimeString().slice(0, 5)

          // Definir tipoEnvio como agendado para manter a data existente
          this.tipoEnvio = 'agendado'
        }
      } else {
        // Nova campanha
        this.tipoEnvio = null
        this.form = {
          name: '',
          template_name: null,
          audience_id: null,
          image_url: '',
          send_date: '',
          description: '',
          attribution_window_hours: 168,
          utm_campaign: '',
          coupon_code: '',
        }
        this.dataEnvio = ''
        this.horaEnvio = ''
        this.previewImagem = null
      }
      this.tentouSalvar = false
    },

    atualizarDataEnvio() {
      if (this.dataEnvio && this.horaEnvio) {
        // Criar data em horário de Brasília (GMT-3) com offset explícito
        this.form.send_date = `${this.dataEnvio}T${this.horaEnvio}:00-03:00`
      }
    },

    getHorarioAtual() {
      const agora = new Date()
      return agora.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Sao_Paulo',
      })
    },

    getHorarioMinimo() {
      const agora = new Date()
      const minimo = new Date(agora.getTime() + 10 * 60 * 1000) // +10 minutos
      return minimo.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Sao_Paulo',
      })
    },

    getHorarioEnvioImediato() {
      const agora = new Date()
      const envio = new Date(agora.getTime() + 10 * 60 * 1000) // +10 minutos
      return envio.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Sao_Paulo',
      })
    },

    formatarDataAgendada() {
      if (!this.dataEnvio || !this.horaEnvio) return ''

      const [ano, mes, dia] = this.dataEnvio.split('-')
      const [hora, minuto] = this.horaEnvio.split(':')

      return `${dia}/${mes}/${ano} às ${hora}:${minuto}`
    },

    selecionarEnvioImediato() {
      this.tipoEnvio = 'imediato'
      this.mostrarErroData = false

      // Calcular data/hora para 10 minutos a partir de agora
      const agora = new Date()
      const envio = new Date(agora.getTime() + 11 * 60 * 1000)

      // Formatar para os campos
      const ano = envio.getFullYear()
      const mes = String(envio.getMonth() + 1).padStart(2, '0')
      const dia = String(envio.getDate()).padStart(2, '0')
      const hora = String(envio.getHours()).padStart(2, '0')
      const minuto = String(envio.getMinutes()).padStart(2, '0')

      this.dataEnvio = `${ano}-${mes}-${dia}`
      this.horaEnvio = `${hora}:${minuto}`
      this.atualizarDataEnvio()
    },

    selecionarEnvioAgendado() {
      this.tipoEnvio = 'agendado'

      // Limpar data/hora para o usuário escolher
      this.dataEnvio = ''
      this.horaEnvio = ''
      this.form.send_date = ''
      this.mostrarErroData = false
    },

    abrirModalAgendamento() {
      // Inicializar valores temporários com os valores atuais
      this.tipoEnvioTemp = this.tipoEnvio
      this.dataEnvioTemp = this.dataEnvio
      this.horaEnvioTemp = this.horaEnvio
      this.mostrarErroDataModal = false
      this.modalAgendamentoVisivel = true
    },

    selecionarTipoEnvioTemp(tipo) {
      this.tipoEnvioTemp = tipo
      this.mostrarErroDataModal = false

      if (tipo === 'imediato') {
        // Calcular data/hora para 10 minutos a partir de agora
        const agora = new Date()
        const envio = new Date(agora.getTime() + 11 * 60 * 1000)

        const ano = envio.getFullYear()
        const mes = String(envio.getMonth() + 1).padStart(2, '0')
        const dia = String(envio.getDate()).padStart(2, '0')
        const hora = String(envio.getHours()).padStart(2, '0')
        const minuto = String(envio.getMinutes()).padStart(2, '0')

        this.dataEnvioTemp = `${ano}-${mes}-${dia}`
        this.horaEnvioTemp = `${hora}:${minuto}`
      }
    },

    confirmarAgendamento() {
      // Validar data se for agendado
      if (this.tipoEnvioTemp === 'agendado') {
        if (!this.dataEnvioTemp || !this.horaEnvioTemp) {
          this.$bvToast.toast('Preencha a data e hora de envio', {
            title: 'Campos obrigatórios',
            variant: 'warning',
            solid: true,
          })
          return
        }

        // Validar se a data é futura (pelo menos 10 minutos)
        const dataEnvio = new Date(`${this.dataEnvioTemp}T${this.horaEnvioTemp}:00`)
        const agora = new Date()
        const minimo = new Date(agora.getTime() + 10 * 60 * 1000)

        if (dataEnvio < minimo) {
          // Corrigir automaticamente para o horário mínimo válido
          this.corrigirParaHorarioMinimo()

          this.$bvToast.toast('O horário foi ajustado automaticamente para o mínimo permitido (10 minutos à frente)', {
            title: 'Horário ajustado',
            variant: 'info',
            solid: true,
            autoHideDelay: 4000,
          })
          return
        }
      }

      // Se for imediato, atualizar para o horário atual + 11 min antes de confirmar
      if (this.tipoEnvioTemp === 'imediato') {
        this.atualizarHorarioImediato()
      }

      // Aplicar valores
      this.tipoEnvio = this.tipoEnvioTemp
      this.dataEnvio = this.dataEnvioTemp
      this.horaEnvio = this.horaEnvioTemp
      this.atualizarDataEnvio()

      this.modalAgendamentoVisivel = false
    },

    corrigirParaHorarioMinimo() {
      const agora = new Date()
      const minimo = new Date(agora.getTime() + 11 * 60 * 1000) // +11 min para ter margem

      const ano = minimo.getFullYear()
      const mes = String(minimo.getMonth() + 1).padStart(2, '0')
      const dia = String(minimo.getDate()).padStart(2, '0')
      const hora = String(minimo.getHours()).padStart(2, '0')
      const minuto = String(minimo.getMinutes()).padStart(2, '0')

      this.dataEnvioTemp = `${ano}-${mes}-${dia}`
      this.horaEnvioTemp = `${hora}:${minuto}`
      this.mostrarErroDataModal = false
    },

    atualizarHorarioImediato() {
      const agora = new Date()
      const envio = new Date(agora.getTime() + 11 * 60 * 1000)

      const ano = envio.getFullYear()
      const mes = String(envio.getMonth() + 1).padStart(2, '0')
      const dia = String(envio.getDate()).padStart(2, '0')
      const hora = String(envio.getHours()).padStart(2, '0')
      const minuto = String(envio.getMinutes()).padStart(2, '0')

      this.dataEnvioTemp = `${ano}-${mes}-${dia}`
      this.horaEnvioTemp = `${hora}:${minuto}`
    },

    corrigirDataEnvioImediato() {
      const agora = new Date()
      const envio = new Date(agora.getTime() + 11 * 60 * 1000) // +11 min para ter margem

      const ano = envio.getFullYear()
      const mes = String(envio.getMonth() + 1).padStart(2, '0')
      const dia = String(envio.getDate()).padStart(2, '0')
      const hora = String(envio.getHours()).padStart(2, '0')
      const minuto = String(envio.getMinutes()).padStart(2, '0')

      this.dataEnvio = `${ano}-${mes}-${dia}`
      this.horaEnvio = `${hora}:${minuto}`
      this.atualizarDataEnvio()
    },

    validarDataTempoReal() {
      // Só valida se ambos os campos (data e hora) estiverem preenchidos
      if (this.dataEnvio && this.horaEnvio && this.form.send_date) {
        const dataValida = this.validarDataEnvio()
        this.mostrarErroData = !dataValida
      } else {
        this.mostrarErroData = false
      }
    },

    async handleMediaUpload(event) {
      const file = event.target.files[0]
      if (!file) return

      const isImage = file.type.startsWith('image/')
      const isVideo = file.type.startsWith('video/')

      // Validar tipo
      if (!isImage && !isVideo) {
        this.$bvToast.toast('Por favor, selecione uma imagem ou vídeo válido', {
          title: 'Formato inválido',
          variant: 'warning',
          solid: true,
        })
        return
      }

      // Validar se o tipo de arquivo corresponde ao tipo esperado pelo template
      if (this.templateTipoMidia === 'VIDEO' && !isVideo) {
        this.$bvToast.toast('Este template requer um vídeo, não uma imagem', {
          title: 'Tipo de mídia inválido',
          variant: 'warning',
          solid: true,
        })
        return
      }

      // Validar tamanho (5MB para imagens, 16MB para vídeos)
      const maxSize = isImage ? 5 * 1024 * 1024 : 16 * 1024 * 1024
      const maxSizeLabel = isImage ? '5MB' : '16MB'

      if (file.size > maxSize) {
        this.$bvToast.toast(`${isImage ? 'A imagem' : 'O vídeo'} deve ter no máximo ${maxSizeLabel}`, {
          title: 'Arquivo muito grande',
          variant: 'warning',
          solid: true,
        })
        return
      }

      // 🆕 Armazenar o arquivo para enviar junto com o FormData
      this.imageFile = file

      // Preview local
      const reader = new FileReader()
      reader.onload = async e => {
        if (isImage) {
          this.previewImagem = e.target.result
          this.previewVideo = null
          this.videoThumbnail = null
        } else if (isVideo) {
          this.previewVideo = e.target.result
          this.previewImagem = null

          // 🎥 Gerar thumbnail do vídeo
          await this.gerarThumbnailVideo(e.target.result)
        }
      }
      reader.readAsDataURL(file)

      this.$bvToast.toast(`${isImage ? 'Imagem' : 'Vídeo'} selecionado! Será enviado ao criar a campanha.`, {
        title: isImage ? 'Imagem pronta' : 'Vídeo pronto',
        variant: 'success',
        solid: true,
      })
    },

    async gerarThumbnailVideo(videoSrc) {
      return new Promise(resolve => {
        try {
          // Criar elemento de vídeo temporário
          const video = document.createElement('video')
          video.src = videoSrc
          video.crossOrigin = 'anonymous'
          video.muted = true
          video.playsInline = true
          video.preload = 'metadata'

          let thumbnailGerada = false

          // Quando o vídeo carregar os metadados
          video.addEventListener('loadedmetadata', () => {
            if (thumbnailGerada) return

            // Ir para 1 segundo (ou 10% do vídeo, o que for menor)
            const seekTime = Math.min(1, video.duration * 0.1)
            video.currentTime = seekTime
          })

          // Quando o vídeo carregar dados suficientes
          video.addEventListener('loadeddata', () => {
            if (thumbnailGerada) return

            // Se ainda não tiver definido currentTime, definir agora
            if (video.currentTime === 0) {
              const seekTime = Math.min(1, video.duration * 0.1)
              video.currentTime = seekTime
            }
          })

          // Quando chegar no frame desejado
          video.addEventListener('seeked', () => {
            if (thumbnailGerada) return

            try {
              // Verificar se o vídeo tem dimensões válidas
              if (video.videoWidth === 0 || video.videoHeight === 0) {
                console.warn('⚠️ Vídeo sem dimensões válidas, tentando novamente...')
                // Tentar novamente após um pequeno delay
                setTimeout(() => {
                  if (!thumbnailGerada && video.videoWidth > 0 && video.videoHeight > 0) {
                    this.capturarFrame(video, resolve)
                    thumbnailGerada = true
                  }
                }, 100)
                return
              }

              this.capturarFrame(video, resolve)
              thumbnailGerada = true
            } catch (error) {
              console.error('❌ Erro ao capturar frame:', error)
              if (!thumbnailGerada) {
                resolve(null)
              }
            }
          })

          // Tratamento de erro
          video.addEventListener('error', e => {
            console.error('❌ Erro ao carregar vídeo:', e)
            if (!thumbnailGerada) {
              resolve(null)
            }
          })

          // Timeout de segurança
          setTimeout(() => {
            if (!thumbnailGerada) {
              console.warn('⚠️ Timeout ao gerar thumbnail')
              resolve(null)
            }
          }, 10000)
        } catch (error) {
          console.error('❌ Erro ao gerar thumbnail:', error)
          resolve(null)
        }
      })
    },

    capturarFrame(video, resolve) {
      try {
        // Criar canvas para capturar o frame
        const canvas = document.createElement('canvas')
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight

        const ctx = canvas.getContext('2d')
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

        // Converter canvas para base64
        this.videoThumbnail = canvas.toDataURL('image/jpeg', 0.8)

        console.log('✅ Thumbnail do vídeo gerada com sucesso', {
          width: canvas.width,
          height: canvas.height,
          thumbnailSize: this.videoThumbnail.length,
        })

        // Forçar atualização do componente
        this.$forceUpdate()

        resolve(this.videoThumbnail)
      } catch (error) {
        console.error('❌ Erro ao capturar frame:', error)
        resolve(null)
      }
    },

    removerMidia() {
      this.form.image_url = ''
      this.previewImagem = null
      this.previewVideo = null
      this.videoThumbnail = null
      this.imageFile = null // 🆕 Limpar o arquivo também
      this.$refs.fileInput.value = ''
    },

    handleOk(bvModalEvent) {
      // Método removido - agora usa avancarOuSalvar
    },

    async salvarCampanha() {
      this.tentouSalvar = true

      await this.ensureMediaFileFromPreviewIfNeeded()

      // Verificar se os campos básicos estão preenchidos
      if (!this.formularioValido) {
        this.$bvToast.toast('Preencha todos os campos obrigatórios', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      // Validar se a data de envio é pelo menos 10 minutos à frente da data/hora atual
      if (!this.validarDataEnvio()) {
        // Se for envio imediato, corrigir automaticamente
        if (this.tipoEnvio === 'imediato') {
          this.corrigirDataEnvioImediato()
          this.$bvToast.toast('O horário de envio foi atualizado para 10 minutos a partir de agora', {
            title: 'Horário atualizado',
            variant: 'info',
            solid: true,
            autoHideDelay: 3000,
          })
        } else {
          // Se for agendado, abrir modal para corrigir
          this.$bvToast.toast('A data e hora de envio devem ser pelo menos 10 minutos à frente. Ajustando automaticamente...', {
            title: 'Horário ajustado',
            variant: 'info',
            solid: true,
            autoHideDelay: 3000,
          })
          this.corrigirDataEnvioImediato()
        }
      }

      // Validar se template que precisa de mídia tem mídia selecionada
      if (!this.validarImagemTemplate()) {
        if (this.isTemplateCarrossel) {
          this.$bvToast.toast('É necessário adicionar uma imagem para cada card do carrossel', {
            title: 'Imagens obrigatórias',
            variant: 'warning',
            solid: true,
          })
        } else {
          const tipoMidia = this.templateTipoMidia === 'VIDEO' ? 'vídeo' : 'imagem ou vídeo'
          this.$bvToast.toast(`É necessário selecionar uma ${tipoMidia} para este template`, {
            title: 'Mídia obrigatória',
            variant: 'warning',
            solid: true,
          })
        }
        return
      }

      // Mostrar confirmação antes de criar/editar
      const isEdicao = !!this.campanhaEdicao
      const confirmed = await this.$bvModal.msgBoxConfirm(
        isEdicao
          ? 'Deseja salvar as alterações desta campanha?'
          : 'Deseja criar essa campanha?',
        {
          title: isEdicao ? 'Confirmar Edição' : 'Confirmar Criação',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: isEdicao ? 'Sim, salvar' : 'Sim, criar',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      )

      if (!confirmed) return

      this.salvando = true

      // Emitir evento para o componente pai
      const campanha = { ...this.form }
      if (this.campanhaEdicao?.id) {
        campanha.id = this.campanhaEdicao.id
      }

      // 🎠 Se for template de carrossel, adicionar dados do carrossel
      if (this.isTemplateCarrossel) {
        campanha.carouselCards = this.carouselCards.map(card => ({
          imageFile: card.imageFile,
          imageUrl: card.imageUrl,
          buttonParam: card.buttonParam || '',
        }))

        console.log('🎠 Campanha com carrossel:', {
          totalCards: campanha.carouselCards.length,
          cards: campanha.carouselCards.map((c, i) => ({
            index: i,
            hasFile: !!c.imageFile,
            hasUrl: !!c.imageUrl,
            buttonParam: c.buttonParam,
          })),
        })
      } else {
        // Adicionar o arquivo de mídia se foi selecionado (upload do usuário OU download automático do template)
        if (this.imageFile) {
          campanha.image = this.imageFile

          // 🎥 Se for vídeo, adicionar thumbnail também
          if (this.videoThumbnail) {
            campanha.videoThumbnail = this.videoThumbnail
          }

          console.log('📤 Campanha com mídia:', {
            fileName: this.imageFile.name,
            fileSize: this.imageFile.size,
            fileType: this.imageFile.type,
          })
        }
      }

      this.$emit('salvar', campanha)

      // ✅ SUCESSO: Marcar como salva e limpar rascunho
      this.campanhaSalva = true
      if (this.draftCache) {
        this.draftCache.clear()
      }

      // Fechar modal apenas se tudo estiver válido
      setTimeout(() => {
        this.salvando = false
        this.fecharModal()
      }, 500)
    },

    // 🎠 Métodos para Carrossel
    abrirUploadCard(index) {
      const inputRef = `cardFileInput${index}`
      if (this.$refs[inputRef] && this.$refs[inputRef][0]) {
        this.$refs[inputRef][0].click()
      }
    },

    async handleCardImageUpload(index, event) {
      const file = event.target.files[0]
      if (!file) return

      // Validar tipo de arquivo
      if (!file.type.startsWith('image/')) {
        this.$bvToast.toast('Por favor, selecione apenas imagens (JPG, PNG, GIF)', {
          title: 'Arquivo inválido',
          variant: 'warning',
          solid: true,
        })
        return
      }

      // Validar tamanho (máx 5MB)
      if (file.size > 5 * 1024 * 1024) {
        this.$bvToast.toast('A imagem deve ter no máximo 5MB', {
          title: 'Arquivo muito grande',
          variant: 'warning',
          solid: true,
        })
        return
      }

      // Criar preview
      const reader = new FileReader()
      reader.onload = e => {
        this.carouselCards[index].previewImage = e.target.result
        this.carouselCards[index].imageFile = file
        this.$forceUpdate()
      }
      reader.readAsDataURL(file)
    },

    removerImagemCard(index) {
      this.carouselCards[index].previewImage = null
      this.carouselCards[index].imageFile = null
      this.carouselCards[index].imageUrl = null

      // Limpar input file
      const inputRef = `cardFileInput${index}`
      if (this.$refs[inputRef] && this.$refs[inputRef][0]) {
        this.$refs[inputRef][0].value = ''
      }

      this.$forceUpdate()
    },

    fecharModal() {
      // Limpar todos os dados do formulário
      this.stepAtual = 0
      this.tipoEnvio = null
      this.form = {
        name: '',
        template_name: null,
        audience_id: null,
        image_url: '',
        send_date: '',
        description: '',
        attribution_window_hours: 168,
        utm_campaign: '',
        coupon_code: '',
      }

      // Limpar preview de mídia
      this.previewImagem = null
      this.previewVideo = null
      this.videoThumbnail = null
      this.imageFile = null
      this.templateMediaType = null

      // Limpar dados do carrossel
      this.carouselCards = []
      this.isCarouselTemplate = false

      // Limpar input de arquivo
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }

      // Limpar data e hora
      this.dataEnvio = ''
      this.horaEnvio = ''

      this.tentouSalvar = false
      this.$emit('input', false)
    },

    // ========== MÉTODOS DE RASCUNHO ==========

    inicializarCache() {
      if (!this.storeUuid) return
      this.draftCache = new DraftCache(`mc_draft_campanha_${this.storeUuid}`, 7)
    },

    async verificarRascunho() {
      if (!this.draftCache || !this.draftCache.exists(this.storeUuid)) return

      const age = this.draftCache.getAge()
      const ageFormatted = formatDraftAge(age)

      try {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          `Você tem uma campanha não finalizada salva ${ageFormatted}. Deseja continuar editando?`,
          {
            title: '📝 Rascunho de Campanha',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Sim, continuar',
            cancelTitle: 'Não, nova campanha',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          },
        )

        if (confirmed) {
          this.carregarRascunho()
        } else {
          this.draftCache.clear()
          this.$bvToast.toast('Rascunho descartado', {
            title: 'Info',
            variant: 'secondary',
            solid: true,
            autoHideDelay: 2000,
          })
        }
      } catch (error) {
        console.error('Erro ao perguntar sobre rascunho:', error)
      }
    },

    carregarRascunho() {
      const draft = this.draftCache.load(this.storeUuid)
      if (!draft) return

      try {
        // Restaurar step
        if (draft.stepAtual !== undefined) {
          this.stepAtual = draft.stepAtual
        }

        // Restaurar form (exceto send_date que não deve vir do cache)
        if (draft.form) {
          const { send_date, ...formSemData } = draft.form
          this.form = { ...this.form, ...formSemData }
          this.form.send_date = '' // Garantir que send_date não é restaurado
        }

        // Data, hora e tipo de envio NÃO são restaurados do cache
        // O usuário deve sempre definir novamente ao continuar um rascunho

        // Restaurar previews de mídia (apenas URLs, não arquivos)
        if (draft.previewImagem) {
          this.previewImagem = draft.previewImagem
        }

        this.$bvToast.toast('Rascunho de campanha recuperado!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
          autoHideDelay: 3000,
        })

        console.log('✅ Rascunho de campanha restaurado:', draft)
      } catch (error) {
        console.error('❌ Erro ao restaurar rascunho de campanha:', error)
        this.$bvToast.toast('Erro ao recuperar rascunho', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },

    salvarRascunho() {
      if (!this.draftCache || !this.value) return

      // Só salva se tiver dados mínimos
      if (!this.form.name && !this.form.template_name) return

      // Não salvar data/hora de envio no cache (deve ser definido novamente)
      const { send_date, ...formSemData } = this.form

      const data = {
        stepAtual: this.stepAtual,
        form: formSemData,
        previewImagem: this.previewImagem,
      }

      this.draftCache.save(data, this.storeUuid)
    },

    salvarRascunhoDebounced() {
      this.salvandoRascunho = true

      if (this.draftTimeout) {
        clearTimeout(this.draftTimeout)
      }

      this.draftTimeout = setTimeout(() => {
        this.salvarRascunho()

        setTimeout(() => {
          this.salvandoRascunho = false
        }, 500)
      }, 1500)
    },

    salvarRascunhoAoFechar() {
      const temDadosRelevantes = this.form.name
        || this.form.description
        || this.form.template_name
        || this.form.audience_id

      if (temDadosRelevantes && !this.campanhaSalva) {
        // Não salvar data/hora de envio no cache (deve ser definido novamente)
        const { send_date, ...formSemData } = this.form

        const data = {
          stepAtual: this.stepAtual,
          form: formSemData,
          previewImagem: this.previewImagem,
        }
        this.draftCache.save(data, this.storeUuid)
        console.log('💾 Rascunho salvo ao fechar modal')
      }
    },
  },
}
</script>

<style scoped>
/* Width customizado do modal */
::v-deep .campaign-modal-custom .modal-dialog {
  max-width: 90rem;
  width: 90rem;
}

/* Steps Indicator */
.steps-indicator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 2rem;
  padding: 0 1rem;
}

.steps-indicator::before {
  content: '';
  position: absolute;
  top: 20px;
  left: calc(12.5% + 20px);
  right: calc(12.5% + 20px);
  height: 2px;
  background: #e0e0e0;
  z-index: 0;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  z-index: 1;
  flex: 1;
  position: relative;
  transition: all 0.3s ease;
}

.step-item:hover .step-circle {
  transform: scale(1.1);
}

.step-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f8f9fa;
  border: 2px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.step-item.active .step-circle {
  background: #9a3092;
  border-color: #9a3092;
  color: white;
  box-shadow: 0 4px 12px rgba(154, 48, 146, 0.3);
}

.step-item.completed .step-circle {
  background: #28c76f;
  border-color: #28c76f;
  color: white;
}

.step-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #6c757d;
  text-align: center;
  transition: all 0.3s ease;
}

.step-item.active .step-label {
  color: #9a3092;
  font-weight: 600;
}

.step-item.completed .step-label {
  color: #28c76f;
}

/* Step Content */
.step-content {
  animation: fadeInUp 0.4s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.step-header {
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  border-left: 4px solid #9a3092;
}

.step-header h5 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.cursor-pointer {
  cursor: pointer;
}

/* Layout de duas colunas no desktop */
.campaign-form-layout {
  margin: 0;
}

.form-column {
  padding-right: 1rem;
}

/* Tamanho da fonte dos campos do formulário */
.form-column ::v-deep .form-group label {
  font-size: 1rem;
  font-weight: 500;
}

.form-column ::v-deep .form-control,
.form-column ::v-deep .form-control:focus,
.form-column ::v-deep select.form-control,
.form-column ::v-deep textarea.form-control {
  font-size: 1rem;
}

.form-column ::v-deep .form-control::placeholder {
  font-size: 0.875rem;
}

.form-column ::v-deep .invalid-feedback {
  font-size: 0.75rem;
}

.form-column ::v-deep .form-text {
  font-size: 0.75rem;
}

.preview-column {
  padding-left: 1rem;
  border-left: 1px solid #e0e0e0;
}

.preview-container {
  position: sticky;
  top: 1rem;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.preview-container::-webkit-scrollbar {
  width: 6px;
}

.preview-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.preview-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.preview-container::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

.preview-title {
  font-weight: 600;
  color: #5e5873;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.preview-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  min-height: 200px;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  background: #f8f9fa;
}

/* Mobile: colunas empilhadas */
@media (max-width: 991.98px) {
  ::v-deep .campaign-modal-custom .modal-dialog {
    max-width: 95%;
    width: 95%;
  }

  .steps-indicator {
    padding: 0;
  }

  .steps-indicator::before {
    left: calc(12.5% + 17.5px);
    right: calc(12.5% + 17.5px);
  }

  .step-circle {
    width: 35px;
    height: 35px;
    font-size: 0.875rem;
  }

  .step-label {
    font-size: 0.75rem;
  }

  .form-column {
    padding-right: 0;
    margin-bottom: 1.5rem;
  }

  .preview-column {
    padding-left: 0;
    border-left: none;
    border-top: 1px solid #e0e0e0;
    padding-top: 1.5rem;
  }

  .preview-container {
    position: static;
  }
}

.upload-area {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.upload-area:hover {
  border-color: #9a3092;
  background: #f9f0f8;
}

.media-preview {
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e0e0e0;
}

.media-preview img,
.media-preview video {
  width: 100%;
  height: auto;
  display: block;
}

.remove-image-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Badge indicando mídia carregada do template */
.template-media-badge {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  font-size: 0.7rem;
  padding: 0.35rem 0.6rem;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Indicador de carregamento da mídia do template */
.template-media-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #f8f9fa;
  border: 2px dashed #9a3092;
  border-radius: 8px;
  color: #9a3092;
  font-weight: 500;
}

/* Template Selector */
.template-selector-wrapper {
  margin-bottom: 0.5rem;
}

.template-action-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.template-action-card {
  background: #fff;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 160px;
  justify-content: center;
}

.template-action-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.template-action-select:hover {
  border-color: #7367f0;
  background: #f8f7ff;
}

.template-action-create:hover {
  border-color: #28c76f;
  background: #f0fff4;
}

.action-icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.template-action-card h6 {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.template-action-card p {
  line-height: 1.4;
}

@media (max-width: 768px) {
  .template-action-cards {
    grid-template-columns: 1fr;
  }
}

/* No Templates Container */
.no-templates-container {
  border: 2px dashed #ffc107;
  border-radius: 12px;
  padding: 2rem;
  background: #fff9e6;
  margin-bottom: 0.5rem;
}

.no-templates-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no-templates-content h5 {
  color: #2c3e50;
  font-weight: 600;
}

.no-templates-content p {
  max-width: 400px;
  margin: 0 auto 1rem;
}

/* No Audiences Container */
.no-audiences-container {
  border: 2px dashed #9a3092;
  border-radius: 12px;
  padding: 2rem;
  background: #f9f0f8;
  margin-bottom: 0.5rem;
}

.no-audiences-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no-audiences-content h5 {
  color: #2c3e50;
  font-weight: 600;
}

.no-audiences-content p {
  max-width: 450px;
  margin: 0 auto 1rem;
  line-height: 1.6;
}

.template-empty {
  border: 2px dashed #d8d6de;
  border-radius: 12px;
  padding: 2rem 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.template-empty:hover {
  border-color: #9a3092;
  background: #f9f0f8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(154, 48, 146, 0.15);
}

.template-selected {
  border: 2px solid #28c76f;
  border-radius: 12px;
  padding: 1rem;
  background: #f0fff4;
  transition: all 0.3s ease;
}

.template-selected:hover {
  box-shadow: 0 4px 12px rgba(40, 199, 111, 0.2);
}

/* Auto-save Indicator */
.auto-save-indicator {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.75);
  color: white;
  border-radius: 20px;
  font-size: 12px;
  z-index: 10000;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* How It Works - Step 1 */
.how-it-works {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.25rem;
  border: 1px solid #e8e8e8;
}

.how-it-works-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.how-it-works-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.how-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.how-description {
  color: #5e5873;
  font-size: 0.85rem;
}

/* Audience Selector (mesmos estilos do template selector) */
.audience-selector-wrapper {
  margin-bottom: 0.5rem;
}

.audience-action-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.audience-action-card {
  background: #fff;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 160px;
  justify-content: center;
}

.audience-action-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.audience-action-select:hover {
  border-color: #7367f0;
  background: #f8f7ff;
}

.audience-action-create:hover {
  border-color: #28c76f;
  background: #f0fff4;
}

.audience-action-card h6 {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.audience-action-card p {
  line-height: 1.4;
}

@media (max-width: 768px) {
  .audience-action-cards {
    grid-template-columns: 1fr;
  }
}

.audience-empty {
  border: 2px dashed #d8d6de;
  border-radius: 12px;
  padding: 2rem 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.audience-empty:hover {
  border-color: #7367f0;
  background: #f3f2ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.15);
}

.audience-selected {
  border: 2px solid #28c76f;
  border-radius: 12px;
  padding: 1rem;
  background: #f0fff4;
  transition: all 0.3s ease;
}

.audience-selected:hover {
  box-shadow: 0 4px 12px rgba(40, 199, 111, 0.2);
}

/* Attribution Window Info */
.attribution-window-info {
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  padding: 1rem;
}

/* Templates Grid (reutilizado no modal de audiências) */
.modal-audiencias-dialog {
  margin: 1.75rem auto;
  max-height: calc(100vh - 3.5rem);
  display: flex;
  flex-direction: column;
}

.modal-audiencias-dialog .modal-content {
  max-height: calc(100vh - 3.5rem);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.templates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.template-card {
  background: white;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 160px;
}

.template-card:hover {
  border-color: #7367f0;
  box-shadow: 0 4px 16px rgba(115, 103, 240, 0.15);
  transform: translateY(-2px);
}

.template-card.template-selected {
  border-color: #28c76f;
  background: #f0fff4;
  box-shadow: 0 4px 16px rgba(40, 199, 111, 0.2);
}

.template-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
}

.template-card.template-selected .template-card-header {
  background: linear-gradient(135deg, #e8f5e9 0%, #f0fff4 100%);
  border-bottom-color: #28c76f;
}

.template-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.template-name {
  flex: 1;
  font-weight: 600;
  font-size: 0.95rem;
  color: #5e5873;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.template-card-body {
  flex: 1;
  padding: 1rem;
  overflow: hidden;
}

.template-preview {
  font-size: 0.85rem;
  line-height: 1.6;
  color: #6e6b7b;
}

.template-card-footer {
  padding: 0.75rem 1rem;
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.template-card.template-selected .template-card-footer {
  background: #f0fff4;
  border-top-color: #d4edda;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  width: 100%;
}

.modal-actions button {
  display: flex;
  align-items: center;
  padding: 0.5rem 1.25rem;
}

/* Send Time Selector - Cards de seleção de envio */
.send-time-selector {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.send-time-card {
  background: #fff;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  position: relative;
}

.send-time-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.send-time-card:first-child:hover {
  border-color: #28c76f;
  background: #f8fff9;
}

.send-time-card:last-child:hover {
  border-color: #7367f0;
  background: #f8f7ff;
}

.send-time-card.selected:first-child {
  border-color: #28c76f;
  background: linear-gradient(135deg, #f0fff4 0%, #e8f5e9 100%);
  box-shadow: 0 4px 12px rgba(40, 199, 111, 0.2);
}

.send-time-card.selected:last-child {
  border-color: #7367f0;
  background: linear-gradient(135deg, #f8f7ff 0%, #ede7f6 100%);
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.2);
}

.send-time-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.send-time-content {
  flex: 1;
}

.send-time-content h6 {
  font-weight: 600;
  color: #2c3e50;
  font-size: 1rem;
}

.send-time-content p {
  line-height: 1.4;
}

.send-time-preview {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  width: fit-content;
}

.send-time-check {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

@media (max-width: 768px) {
  .send-time-selector {
    grid-template-columns: 1fr;
  }
}

/* Schedule Fields - Campos de agendamento */
.schedule-fields {
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.25rem;
}

.schedule-fields-header {
  display: flex;
  align-items: center;
  color: #5e5873;
}

/* Animação slide-fade */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* Schedule Selector Card - Card para abrir modal de agendamento */
.schedule-selector-card {
  background: #fff;
  border: 2px dashed #d8d6de;
  border-radius: 12px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.schedule-selector-card:hover {
  border-color: #7367f0;
  background: #f8f7ff;
}

.schedule-selector-card .schedule-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Schedule Selected Card - Card mostrando agendamento definido */
.schedule-selected-card {
  background: #fff;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.schedule-selected-card.immediate {
  border-color: #28c76f;
  background: linear-gradient(135deg, #f0fff4 0%, #e8f5e9 100%);
}

.schedule-selected-card.scheduled {
  border-color: #7367f0;
  background: linear-gradient(135deg, #f8f7ff 0%, #ede7f6 100%);
}

.schedule-selected-card .schedule-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Modal de Agendamento */
.schedule-modal-content {
  padding: 0.5rem 0;
}

.schedule-option-card {
  background: #fff;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
  position: relative;
}

.schedule-option-card:last-of-type {
  margin-bottom: 0;
}

.schedule-option-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.schedule-option-card:first-of-type:hover {
  border-color: #28c76f;
  background: #f8fff9;
}

.schedule-option-card:nth-of-type(2):hover {
  border-color: #7367f0;
  background: #f8f7ff;
}

.schedule-option-card.selected:first-of-type {
  border-color: #28c76f;
  background: linear-gradient(135deg, #f0fff4 0%, #e8f5e9 100%);
  box-shadow: 0 4px 12px rgba(40, 199, 111, 0.2);
}

.schedule-option-card.selected:nth-of-type(2) {
  border-color: #7367f0;
  background: linear-gradient(135deg, #f8f7ff 0%, #ede7f6 100%);
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.2);
}

.schedule-option-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.schedule-option-card h6 {
  font-weight: 600;
  color: #2c3e50;
  font-size: 1rem;
}

.schedule-option-card p {
  line-height: 1.4;
}

.schedule-option-check {
  flex-shrink: 0;
  margin-left: 1rem;
}

</style>
